import Toggleable from '../../mixins/toggleable'
import Contextualable from '../../mixins/contextualable'

export default {
  name: 'alert',

  mixins: [Contextualable, Toggleable],

  props: {
    dismissible: { type: Boolean },
    icon: { type: [String, Boolean], default: true },
  },

  computed: {
    classes () {
      return {
          ...this.$contextualClasses,
          'alert': true,
          'alert--dismissible': this.dismissible,
        }
    },

    iconName () {
      if(typeof this.icon == 'string') return this.icon
      else if(this.error || this.warning) return 'warn'
      else return 'bell'
    }
  },

  render (h) {
    const children = [h('div', this.$slots.default)]

    if(this.icon !== false) {
      children.unshift(
        h('n-icon', {
          'class': 'alert__icon mr-2',
          props: { }
        }, this.iconName)
      )
    }

    if (this.dismissible) {
      children.push(h('n-button', {
        props: { icon: true, small:true, flat:true },
        'class': { 'ma-0': true, ...this.$contextualClasses },
        nativeOn: { click: () => (this.$emit('input', false)) }
      }, [h('n-icon', {}, 'close')]))
    }

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }]
    }, children)
  }
}
